import type { SchemaFoundPage, SchemaSize } from '@zeed/content'
import type { LoggerInterface } from '@zeed/zeed'
import type { OcrWorkerOptions } from './worker'
import { Logger } from '@zeed/zeed'
import { convertTesseractPage } from './convert'
import { getOcrWorker } from './worker'

const log: LoggerInterface = Logger('ocr')

export interface OcrOptions extends OcrWorkerOptions {
  /** DPI hint for the image (default: 300) */
  dpi?: number
}

export type OcrImageSource = Blob | ImageBitmap | HTMLImageElement | HTMLCanvasElement | OffscreenCanvas

/**
 * Run OCR on a single image and return a SchemaFoundPage
 * compatible with `@zeed/content` FeaturesPage.
 */
export async function ocrImage(
  source: OcrImageSource,
  size: SchemaSize,
  options: OcrOptions = {},
): Promise<SchemaFoundPage> {
  const worker = await getOcrWorker(options)
  log('recognizing image', size.w, 'x', size.h)

  const result = await worker.recognize(source as any, undefined, { blocks: true })
  const page = convertTesseractPage(result.data, size)

  if (options.dpi)
    page.dpi = options.dpi

  return page
}

/**
 * Run OCR on multiple images and return SchemaFoundPage[].
 * Pages are numbered starting from 0.
 */
export async function ocrImages(
  sources: { source: OcrImageSource, size: SchemaSize }[],
  options: OcrOptions = {},
): Promise<SchemaFoundPage[]> {
  const pages: SchemaFoundPage[] = []

  for (let i = 0; i < sources.length; i++) {
    const { source, size } = sources[i]
    const page = await ocrImage(source, size, options)
    page.page = i
    pages.push(page)
  }

  return pages
}
